"use strict";

import {onFind} from "@elements/init-modules-in-scope";
import {on, hasClass, removeClass, findAll, find, findIn, findAllIn} from "@elements/dom-utils";


export function scrollTop($element) {
    let navOffset = matchMedia('(max-width: 767px)').matches ? 170 : 200;
    let offset = $element.getBoundingClientRect().top + window.pageYOffset - navOffset;
    if (window.pageYOffset > offset) {
        try {
            window.scroll({
                top: offset,
                behavior: 'smooth'
            });
        } catch (e) {
            window.scrollTo(0, offset)
        }
    }
}